const initialState = {
   isButtonFetching: false,
   isSubscribe: false,
   errors: {},
   data: {},
   isFetching: true,
};

export default initialState;
